import { BaseUserDto, UserDto } from 'src/dtos';
import { mapAccountDtoToModel } from 'src/mappers';
import { User, UserDetails } from 'src/models';

export const mapUserDtoToModel = (item: BaseUserDto): User => ({
  id: item.id,
  firstName: item.firstName,
  middleName: item.middleName,
  lastName: item.lastName,
  suffix: item.suffix,
  email: item.email,
  phoneNumber: item.phoneNumber,
  isLocked: item.isLocked,
  isClosed: item.isClosed,
  isApproved: item.isApproved,
  isMfaEnabled: item.isMfaEnabled,
  signUpStatus: item.signUpStatus,
  hasAccounts: item.hasAccounts,
  resetPasswordAttempts: item.resetPasswordAttempts,
  createdAt: item.createdAt,
});

export const mapUserDetailsDtoToModel = (item: UserDto): UserDetails => ({
  ...mapUserDtoToModel(item),
  accounts: item.accounts.map(mapAccountDtoToModel),
  accountLinks: item.accountLinks?.map(mapAccountDtoToModel) ?? [],
  postcloseOffers: item.postcloseOffers,
  dashboardSettings: item.dashboardSettings,
});
